import { render, staticRenderFns } from "./offline_activity_apply_list.vue?vue&type=template&id=bc02e4fe"
import script from "./offline_activity_apply_list.vue?vue&type=script&lang=js"
export * from "./offline_activity_apply_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports